/**
 * @property itemName {string} item name
 * @property DOM
 */
import React, { Component } from "react";

class List extends Component {
  render() {
    return (
      <li className="segment-detail-list">
        <span style={{ width: "180px" }}>{this.props.itemName}</span>
        <section style={{ textAlign: "right" }}>{this.props.children}</section>
      </li>
    );
  }
}

export default List;



// WEBPACK FOOTER //
// ./src/components/NewSegmentDetail/List.jsx